import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock, Linkedin, Instagram, Facebook } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import Logo from "@/components/brand/Logo";
import { CONTACT_INFO, whatsappHref } from "@/constants/contact";

export default function Footer() {
  return (
    <footer className="relative bg-brand-navy text-white/90">
      <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-transparent via-brand-teal to-transparent" />
      <div className="container-brand py-16 md:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="inline-block bg-white p-3 rounded-lg">
            <Logo className="h-14 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/70">
            A Pune-based recruitment consultancy connecting employers with
            capable IT and Non-IT professionals through focused sourcing,
            structured screening and responsive coordination.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" aria-label="LinkedIn" className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#" aria-label="Instagram" className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" aria-label="Facebook" className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest">
            Quick Links
          </h4>
          <span className="teal-rule mt-3 mb-5" />
          <ul className="space-y-3 text-sm text-white/80">
            <li><Link to="/" className="hover:text-brand-teal transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-brand-teal transition-colors">About Us</Link></li>
            <li><Link to="/services" className="hover:text-brand-teal transition-colors">Services</Link></li>
            <li><Link to="/contact" className="hover:text-brand-teal transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest">
            Services
          </h4>
          <span className="teal-rule mt-3 mb-5" />
          <ul className="space-y-3 text-sm text-white/80">
            <li>IT Recruitment</li>
            <li>Non-IT Recruitment</li>
            <li>Permanent Hiring</li>
            <li>Executive Search</li>
            <li>Bulk &amp; Campus Hiring</li>
            <li>Contract Staffing</li>
            <li>HR Consulting &amp; Payroll</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest">
            Reach Us
          </h4>
          <span className="teal-rule mt-3 mb-5" />
          <ul className="space-y-4 text-sm text-white/85">
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-0.5 text-brand-teal shrink-0" />
              <span>{CONTACT_INFO.location}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-0.5 text-brand-teal shrink-0" />
              <a href={CONTACT_INFO.callHrefTel} className="hover:text-brand-teal transition-colors">
                {CONTACT_INFO.callNumberDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <FaWhatsapp className="h-4 w-4 mt-0.5 text-brand-teal shrink-0" />
              <a href={whatsappHref()} target="_blank" rel="noopener noreferrer" className="hover:text-brand-teal transition-colors">
                {CONTACT_INFO.whatsappNumberDisplay}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-0.5 text-brand-teal shrink-0" />
              <a href={CONTACT_INFO.emailHref} className="hover:text-brand-teal transition-colors break-all">
                {CONTACT_INFO.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="h-4 w-4 mt-0.5 text-brand-teal shrink-0" />
              <span>{CONTACT_INFO.hoursShort}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-brand py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-white/60">
          <p>© 2026 Ascend Tech Solutions. All rights reserved.</p>
          <p className="text-white/50">
            Recruitment · Talent Acquisition · HR Consulting · Pune, India
          </p>
        </div>
      </div>
    </footer>
  );
}
